module.exports = "### Accessibility Built-in\n\nMineral has been designed and built to be accessible to all from the very\nbeginning. The components do the hard work for you, through the consistent\napplication of color contrast ratios, standards compliant markup, and thoughtful\ndesign, informed by researching best practices and testing with assistive\ntechnology.\n"


//////////////////
// WEBPACK FOOTER
// ./src/website/app/pages/Home/content/accessibility.md
// module id = 509
// module chunks = 9